import axios from 'axios';
import { EndPoints, getParams, Http, TypeParams } from '../utils';
import { ItemInfo } from '../../typescript/itemInfo';
import { Note, SamplingClassification } from '../../../features/typescript/notes/notes';
import { SatellitalImagesApiList } from '../../../features/typescript/satellital/satellital_images';
import { NDVIInfo, SatellitalLayersInfo, ZonificationInfo } from '../../../features/typescript/satellital/layers';
import { RanchVariableData, RanchVariablesCategorized, SatellitalChartStatistics, SatellitalValues } from '../../../features/typescript/satellital/evolution_chart';

export const ItemWithSinistersApi = {
    //Detalle de item con lista de siniestros
    getItemWithSinistersInfo: (): Promise<ItemInfo> => {
        let url = `${EndPoints.ItemWithSinistersUrls.DETAIL_INFO}`;
        return Http.get(url).then(response => response.data)
    },

    //Notas de un siniestro
    getSinisterNotes: (id: number): Promise<{
        ranch_notes: Note[]
    }> => {
        let url = `${EndPoints.ItemWithSinistersUrls.SINISTER_NOTES}`;
        return Http.get(url, {
            params: getParams([{ key: TypeParams.ID, value: id }])
        }).then(response => response.data)
    },

    //Agregar nota a un siniestro
    postNote: (claim_id: number, note: Note): Promise<{
        message: string
    }> => {
        let url = `${EndPoints.ItemWithSinistersUrls.SINISTER_NOTES}`;
        return Http.post(url, {
            claim_id,
            ...note
        }).then(response => response.data)
    },

    patchNote: (note: Note): Promise<{
        message: string
    }> => {
        let url = `${EndPoints.ItemWithSinistersUrls.SINISTER_NOTES}?${TypeParams.ID}=${note.id}`;
        return Http.patch(url, {
            ...note
        }).then(response => response.data)
    },

    deleteNote: (id: number): Promise<any> => {
        let url = `${EndPoints.ItemWithSinistersUrls.SINISTER_NOTES}?${TypeParams.ID}=${id}`;
        return Http.delete(url, {
             params: getParams([{ key: TypeParams.ID, value: id }])
        }).then(response => response.data)
    },

    getSamplingClassifications: (claimId: number): Promise<{
        sampling_classifications: SamplingClassification[]
    }> => {
        const url = `${EndPoints.ItemWithSinistersUrls.SAMPLING_CLASSIFICATION}`;
        return Http.get(url, {
            params: getParams([{ key: TypeParams.ID, value: claimId }])
        }).then(response => response.data)
    },

    //---Satelital---------------------------
     getSatellitalImages: (id: number): Promise<{
        images: SatellitalImagesApiList,
        values: SatellitalValues
     }> => {
        let url = `${EndPoints.ItemWithSinistersUrls.SATELLITAL_IMAGES}`;
        return Http.get(url, {
            params: getParams([{ key: TypeParams.ID, value: id }])
        }).then(response => response.data)
    },

    //---Capas satelitales
     getSatellitalLayers: (id: number): Promise<SatellitalLayersInfo> => {
        let url = `${EndPoints.ItemWithSinistersUrls.MAP_LAYERS}`;
        return Http.get(url, {
            params: getParams([{ key: TypeParams.ID, value: id }])
        }).then(response => response.data)
    },

    //Valores - grafico satelital
    getSatellitialVariablesWithValues: (id): Promise<RanchVariablesCategorized> => {
        const url = `${EndPoints.ItemWithSinistersUrls.SATELLITAL_VALUES}`;
        return Http.get(url, {
            params: getParams([
            { key: 'id', value: id }
            ])
        }).then(response => response.data);
    },

    //Estadisticas - grafico satelital
    getStatsForSatellitalChart: (id, cancelToken:any, datetime_from?: string, datetime_to?: string): Promise<SatellitalChartStatistics> => {
        const url = `${EndPoints.ItemWithSinistersUrls.STATS_SATELLITAL_VALUES}`;
        return Http.get(url, {
            cancelToken: cancelToken.token,
            params: getParams([
                { key: TypeParams.ID, value: id },
                ...(datetime_from ? [{ key: TypeParams.DATE_FROM, value: datetime_from }] : []),
                ...(datetime_to ? [{ key: TypeParams.DATE_TO, value: datetime_to }] : []),
            ])
        }).then(response => response.data)
    },

    //Zonificar lote
    postZonification: (config: {
        id: number,
        satellital_image_id: number
    }): Promise<{
        message: string,
        zonified: ZonificationInfo
    }> => {
        return Http.post(EndPoints.ItemWithSinistersUrls.ZONIFICATION, config).then(response => response.data)
    },


    //Ndvi Diff
    postNdviDiff: (config: {
        id: number,
        initial_image_id: number,
        final_image_id: number
    }): Promise<{
        message: string,
        ndvi: NDVIInfo
    }> => {
        return Http.post(EndPoints.ItemWithSinistersUrls.NDVI_DIFF, config).then(response => response.data)
    },
};
